import { Grid } from '@material-ui/core'
import React, { FunctionComponent } from 'react'
import { MdClose } from 'react-icons/md'
import { colors } from 'shared/styles/colors'
import dimensions from 'shared/styles/dimensions'
import Button from '../Button'
import { IDrawerProps } from './DrawerComponent.types'
import { Container, Backdrop, SideBar } from './styles'

const Drawer: FunctionComponent<IDrawerProps> = ({
  children,
  width,
  open,
  onCloseModal,
}: IDrawerProps) => {
  const closeDrawer = () => {
    if (open) {
      onCloseModal()
    }
  }
  return (
    <Container open={open}>
      <Backdrop onClick={closeDrawer} />
      <SideBar width={width}>
        <Grid container justifyContent="flex-end">
          {onCloseModal && (
            <Button transparent={true} size="small" onClick={onCloseModal}>
              <MdClose color={colors.blue} size={dimensions.medium} />
            </Button>
          )}
        </Grid>
        {children}
      </SideBar>
    </Container>
  )
}

export default Drawer
